import { render, staticRenderFns } from "./station-detail-history.vue?vue&type=template&id=23edb200&scoped=true&"
import script from "./station-detail-history.vue?vue&type=script&lang=js&"
export * from "./station-detail-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23edb200",
  null
  
)

export default component.exports